import { Colors, Shadows } from 'cio-design-library/design-tokens'
import styled, { css } from 'styled-components'
import ReactSlider from 'rc-slider'

const commonDisabledStyles = css`
  background-color: ${Colors.Neutral10};

  svg {
    fill: ${Colors.Neutral40};
  }
`

export const CustomHandle = styled.div<{ $position: number; $disabled?: boolean }>`
  position: absolute;
  z-index: 1;
  transform: translateX(-50%);
  width: 24px;
  height: 32px;
  border-radius: 8px;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.White};
  left: ${({ $position }) => `clamp(12px, ${$position}%, calc(100% - 12px))`};
  box-shadow: ${Shadows.lightWithBorderShadowLow};

  &:hover {
    background-color: ${Colors.Blue10};
    box-shadow: ${Shadows.lightWithBorderShadowMid};

    svg {
      fill: ${Colors.Blue50};
    }
  }

  &:active {
    background-color: ${Colors.Blue20};

    svg {
      fill: ${Colors.Blue60};
    }
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      cursor: not-allowed;
      ${commonDisabledStyles}

      &:hover {
        ${commonDisabledStyles}
      }

      &:active {
        ${commonDisabledStyles}
      }
    `}
`

export const Slider = styled(ReactSlider)`
  position: relative;
  height: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 12px 0 0 12px;

  & .rc-slider-rail {
    position: absolute;
    height: 8px;
    left: 0;
    top: 50%;
    width: 100%;
    margin-top: -3px;
    background-color: ${Colors.Neutral15};
    border-radius: 3px;
  }

  & .rc-slider-track {
    position: absolute;
    left: 0;
    top: 50%;
    height: 8px;
    margin-top: -3px;
    background-color: ${Colors.Blue50};
    border-radius: 3px;
  }

  & .rc-slider-mark {
    margin-top: -14px;

    & .rc-slider-mark-text {
      &:last-child {
        left: calc(100% - 8px) !important;
      }
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      & .rc-slider-track {
        background-color: ${Colors.Neutral15};
      }
    `}
`

export const Segment = styled.div<{ $isActive?: boolean }>`
  position: absolute;
  cursor: pointer;
  width: 8px;
  height: 16px;
  border-radius: 12px;
  background-color: ${({ $isActive }) => ($isActive ? Colors.Blue50 : Colors.Neutral15)};
`
